import React from "react";
import _ from "underscore";
import classNames from "classnames";

import { getTypeIcon } from "../../../shared/components/inspiration/resources";
import { ContentTypeEnumHelper, MonthEnumHelper } from "@travellocal/utils/enumHelper";
import SvgIcon, { DEFAULT_ICON_SVG } from "../../../core/atoms/svgIcon";

import "./filters.scss";

interface FilterProps<T> {
  choices: T[];
  selected: T[];
  onSelectionToggle: (newSelection :T[]) => void;
}

class SimpleFilterBase<T> extends React.Component<FilterProps<T>, {}> {
  constructor(props, private getId: (t: T) => number) {
    super(props);
  }

  protected onToggle(item: T) {
    let selection = this.props.selected || [];
    let index = _.indexOf(selection.map(x => this.getId(x)), this.getId(item));
    if (index >= 0) {
      selection.splice(index, 1);
    }
    else {
      selection.push(item);
    }

    this.props.onSelectionToggle(selection);
  }
}

export class ContentTypeFilter extends SimpleFilterBase<ContentType> {
  constructor(props) {
    super(props, type => type);
  }

  public render() {
    let choices = this.props.choices || [];

    return (
      <div className="filter">
        <div className="toggles">
        {choices.map(type => {
          let isSelected = _.any(this.props.selected, t => t === type);

          return (
            <div key={`filter-type-toggle-${type}`}
                 className={classNames("toggle", {"selected": isSelected } )}
                 onClick={e => this.onToggle(type)}>
              <SvgIcon svg={getTypeIcon(type) || DEFAULT_ICON_SVG} />
              <label>{ContentTypeEnumHelper.toFriendlyName(type)}</label>
            </div>
          );
        })
        }
        </div>
      </div>
    );
  }
}

export class ThemeFilter extends SimpleFilterBase<ITheme> {
  constructor(props) {
    super(props, theme => theme.id);
  }

  public render() {
    let { choices, selected } = this.props;

    let hash: {[id: string]: ITheme} = {};
    for (let x of (choices||[]).concat(selected||[])) {
      hash[x.id] = x;
    }

    // secondary themes might be selected via qs
    let primaries: ITheme[] = [], secondaries: ITheme[] = [];
    for (let key of Object.keys(hash)) {
      let theme = hash[key];
      if (theme.inspiration) {
        primaries.push(theme);
      }
      else {
        secondaries.push(theme);
      }
    }

    primaries.sort((a, b) => a.name.localeCompare(b.name));
    secondaries.sort((a, b) => a.name.localeCompare(b.name));

    return (
      <div className="filter">
        <div className="toggles">
        {primaries.map(theme => {
          let isSelected = _.any(this.props.selected, t => t.id === theme.id);

          return (
            <div key={`filter-theme-toggle-${theme.id}`}
                 className={classNames("toggle", {"selected": isSelected } )}
                 onClick={e => this.onToggle(theme)}>
              <SvgIcon svg={theme.icon || DEFAULT_ICON_SVG} />
              <label>{theme.name}</label>
            </div>
          );
        })}
        {secondaries.map(theme => {
          let isSelected = _.any(this.props.selected, t => t.id === theme.id);

          // Same but with no icon
          return (
            <div key={`filter-theme-toggle-${theme.id}`}
                 className={classNames("toggle", {"selected": isSelected } )}
                 onClick={e => this.onToggle(theme)}>
              <label>{theme.name}</label>
            </div>
          );
        })}
        </div>
      </div>
    );
  }
}

export class MonthFilter extends SimpleFilterBase<Month> {
  constructor(props) {
    super(props, month => month);
  }

  public render() {
    let choices = this.props.choices || [];

    return (
      <div className="filter month">
        <div className="toggles">
        {choices.map(month => {
          let isSelected = _.any(this.props.selected, m => month === m);

          return (
            <div key={`filter-month-toggle-${month}`}
                 className={classNames("toggle", {"selected": isSelected })}
                 onClick={e => this.onToggle(month)}>
              <label>{MonthEnumHelper.toFriendlyName(month)}</label>
            </div>
          );
        })
        }
        </div>
      </div>
    );
  }
}

export { default as LocationFilter } from "./locationFilter";
export { Accordion as FilterAccordion, FilterPanel, PanelDefinition as FilterPanelDefinition } from "./filterAccordion";
